import { widgetPlanIds } from '@/data/widgetPlanIds';
import { WindowType } from '@/enums/WindowType';
import { localeStore } from '@/locale';
import { atom } from 'nanostores';

export class WidgetStore {
  $style = atom('scandy');

  $environmentType = atom('city');

  $planId = atom('');

  $widgetUrl = atom('');

  $isStyleOpened = atom(false);

  $isEnvironmentTypeOpened = atom(false);

  store;

  constructor(store) {
    this.store = store;

    this.updateState();
  }

  setStyle(value) {
    this.$style.set(value);
    this.updateState();
  }

  setEnvironmentType(value) {
    this.$environmentType.set(value);
    this.updateState();
  }

  openStyleSelect() {
    this.$isStyleOpened.set(true);
    this.closeEnvironmentTypeSelect();
  }

  openEnvironmentTypeSelect() {
    this.$isEnvironmentTypeOpened.set(true);
    this.closeStyleSelect();
  }

  closeStyleSelect() {
    this.$isStyleOpened.set(false);
  }

  closeEnvironmentTypeSelect() {
    this.$isEnvironmentTypeOpened.set(false);
  }

  closeAll() {
    this.closeStyleSelect();
    this.closeEnvironmentTypeSelect();
  }

  updateState() {
    const style = this.$style.get();
    const type = this.$environmentType.get();
    this.$planId.set(widgetPlanIds[style]?.[type]?.[WindowType.Panoramic]);

    const params = new URLSearchParams({
      id: this.$planId.get(),
      type,
      style,
      lang: localeStore.lang,
      landing: 1,
    });
    this.$widgetUrl.set(`${window.location.origin}/widget/?${params}`);
  }
}
